// extracted by mini-css-extract-plugin
export default {"desktop":"desktop","newsFeed":"EER1xqEC","title":"EaLJ40Kk","mobile":"mobile","moreButton":"rPprc9OL"};